import { render, staticRenderFns } from "./ComitenteSelect.vue?vue&type=template&id=95cadfd0&"
import script from "./ComitenteSelect.vue?vue&type=script&lang=js&"
export * from "./ComitenteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports